import * as React from 'react';

interface ErrorMessageProps {
  defaultMessage?: string;
  message?: React.ReactNode;
}

export default function ErrorMessage(props: ErrorMessageProps) {
  return (
    <div className="error-message" role="alert" key={props.defaultMessage}>
      {props.message || props.defaultMessage}
    </div>
  );
}
